import React from 'react';
import style from './mobileMenu.module.scss';
import Avatar from 'components/avatar/avatar';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { logout } from 'store/auth/authSlice';
import { selectUser } from 'store/auth/authSlice';
import { Link } from 'react-router-dom';
import map from 'lodash-es/map';
import { selectCategories } from 'store/page/pageSlice';
import { useMatch, useSearchParams } from 'react-router-dom';
import SectionLink from 'components/sectionLink/sectionLink';
import SharpIcon from 'icons/sharp';
import UserIcon from 'icons/user';
import HomeIcon from 'icons/home';
import cx from 'classnames';
import ExitIcon from 'icons/exit';

const icons = {
  home: <HomeIcon />,
  toProfile: <UserIcon />,
  toTags: <SharpIcon />,
};

const mainCategories = ['photos', 'vectors', 'illustrations'];

export default function MobileMenu({
  toggleMobileMenu,
}: {
  toggleMobileMenu: () => void;
}) {
  const dispatch = useAppDispatch();
  const categories = useAppSelector(selectCategories);
  const [searchParams] = useSearchParams();
  const mainChecker = useMatch('/:name/*')?.params.name;
  const isSearchContext = mainChecker === 'search' || mainChecker === 'mapping';
  const user = useAppSelector(selectUser);

  const linkHandler = () => toggleMobileMenu();

  return (
    <div className={style.container}>
      <div className={style['avatar-container']}>
        <Avatar className={style.avatar}></Avatar>
        <span className={style.name}>{`${user?.name} ${user?.surname}`}</span>
      </div>
      <div className={style.navigation}>
        <div
          className={cx(
            style.main,
            mainChecker && mainCategories.includes(mainChecker)
              ? style.selected
              : ''
          )}
        >
          {icons['home']}
          <span className={'font20'}>Главная</span>
        </div>
        <div className={style['main-categories']}>
          {map(categories, (category) => {
            if (isSearchContext) {
              searchParams.set('category', category.id);
            }

            searchParams.delete('page');

            return (
              <SectionLink
                onClick={linkHandler}
                className={'adaptive-f18'}
                key={category.id}
                categoryId={category.id}
                to={
                  isSearchContext
                    ? `/search?${searchParams.toString()}`
                    : `${category.href}?${searchParams.toString()}`
                }
              >
                {category.id}
              </SectionLink>
            );
          })}
        </div>
        <div
          className={cx(
            style.pageLink,
            'font20',
            mainChecker && mainChecker === 'cabinet' ? style.selected : ''
          )}
        >
          {icons['toProfile']}
          <Link
            onClick={linkHandler}
            to={`/cabinet?category=Фотографии`}
            color={'inherit'}
          >
            Профиль
          </Link>
        </div>
        <div
          className={cx(
            style.pageLink,
            'font20',
            mainChecker && mainChecker === 'tags' ? style.selected : ''
          )}
        >
          {icons['toTags']}
          <Link onClick={linkHandler} to={`/tags`} color={'inherit'}>
            Список тегов
          </Link>
        </div>
      </div>
      <div onClick={() => dispatch(logout())} className={style.exit}>
        <ExitIcon strokeColor="#6a4192"></ExitIcon>
        <span className={'font20'}>Выход</span>
      </div>
    </div>
  );
}
